import React from "react";

import Page from "../Page";
import WebGis from "./WebGis";


const Dashboard = () => {
    return <Page heightFullDisplay>
        <WebGis />
    </Page>
}


export default Dashboard;